module.exports = __webpack_public_path__ + "static/ux-ui-design-9c9884699ff433fc143a044390cecf78.svg";